import axios from "axios";

export const http = axios.create({
  // baseURL: "https://rupioodms-backend.rupioo.in",
  baseURL: "http://localhost:7070",
  withCredentials: false, // set true if you use cookies/sessions
});
